/* eslint-disable react/no-danger */
import usePaperCitation from "@/hooks/useCitation";
import useTranslation from "@/hooks/useTranslation";
import { sanitizeCitation } from "@/utils/sanitize.util";
import { BlockOutlined } from "@ant-design/icons";
import { Divider, Drawer, Spin } from "antd";
import React, { useState } from "react";
import styles from "../styles.module.less";

const {
  itemContainer,
  itemIcon,
  itemText,
  citationStyle,
  citationFormat,
} = styles;

interface CardProps {
  citation: { format: string; result: string };
}

const CitationCard: React.FC<CardProps> = ({ citation }) => {
  return (
    <div>
      <Divider className={citationFormat}>{citation?.format}</Divider>
      <div
        className={citationStyle}
        dangerouslySetInnerHTML={{ __html: sanitizeCitation(citation?.result) }}
      />
    </div>
  );
};

interface IProps {
  doi: string;
}

const Citation: React.FC<IProps> = ({ doi }) => {
  const { t } = useTranslation("explore");
  const { loadCitation, loading, data } = usePaperCitation(doi);
  const [visible, setVisible] = useState(false);

  return (
    <>
      <div
        className={itemContainer}
        key={doi}
        onClick={() => {
          loadCitation();
          setVisible(true);
        }}
      >
        <div className={itemIcon}>
          <BlockOutlined />
        </div>
        <div className={itemText}>{t("tab.helper.citation")}</div>
      </div>
      <Drawer
        title={t("tab.helper.citation")}
        visible={visible}
        closable
        onClose={() => setVisible(false)}
        placement="right"
        width="20rem"
      >
        <Spin spinning={loading}>
          {data?.getCitationBundle?.map(
            (citation: { format: string; result: string }) => (
              <CitationCard citation={citation} key={citation?.result} />
            )
          )}
        </Spin>
      </Drawer>
    </>
  );
};

export default Citation;
